// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3Ypt8","amount":"Amount_amount__foC5d","tip":"Amount_tip__ITVua","tipHeader":"Amount_tipHeader__3ZuPf","tipsWrap":"Amount_tipsWrap__3L2yP"};